/* eslint-disable max-len */
import React from 'react';
function High() {
    return (React.createElement("g", { width: "24", height: "24", viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg" },
        React.createElement("path", { d: "M4.00195 12.0002L5.41195 13.4102L11.002 7.83024L11.002 20.0002L13.002 20.0002L13.002 7.83024L18.592 13.4102L20.002 12.0002L12.002 4.00024L4.00195 12.0002Z" })));
}
export default High;
